import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TableImage from "../../shared/Table/TableImage";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import PrimaryButton from "../../shared/Button/PrimaryButton";
import { exportTableToCsv } from "../../utils/exportTableCsv";

export default function ExecutiveTable({ heading, allExecutives, loading, history, search, setSearch, onDelete }) {
    const [selectedRow, setSelectedRow] = useState([]);

    const actions = (d) => {
        return (
            <div className="flex justify-content-around">
                <i className="pi pi-eye cursor-pointer text-dark" onClick={() => history(`/executive/view/${d._id}`)}></i>
                <i className="pi pi-pencil cursor-pointer text-dark ml-2 mr-2" onClick={() => history(`/executive/edit/${d._id}`)}></i>
                <i className="pi pi-trash cursor-pointer text-dark" onClick={() => onDelete(d._id)}></i>
            </div>
        );
    };

    const image = (r) => {
        const image = r.image;
        return <TableImage image={image} />;
    };
    const dateFilterTemplate = (options) => {
        return (
            <Calendar
                value={options.value}
                onChange={(e) => {
                    options.filterCallback(e.value, options.index);
                }}
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
                mask="99/99/9999"
            />
        );
    };
    const filters = {
        time: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        subscriptionExpireOn: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    };
    const formatDate = (date) => {
        return date?.toLocaleDateString?.("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    const exportAll = () => {
        exportTableToCsv("executives.csv", allExecutives, [
            { header: "Name", value: (row) => [row.firstName, row.lastName].filter(Boolean).join(" ") || "-" },
            { header: "Email", value: "email" },
            { header: "Date", value: (row) => (row.time ? formatDate(row.time) : "-") },
        ]);
    };

    return (
        <>
            <div className="col-12">
                <div className="card">
                    <div className="flex justify-content-between mb-4">
                        <h5>{heading}</h5>
                        {setSearch ? (
                            <div className="p-input-icon-left mx-2">
                                <i className="pi pi-search" />
                                <InputText value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search" />
                                <PrimaryButton onClick={() => history(`/executive/add`)}>Add Executive</PrimaryButton>
                                <PrimaryButton
                                    label="Export CSV"
                                    icon="pi pi-download"
                                    onClick={exportAll}
                                    disabled={!allExecutives.length}
                                    severity="success"
                                />
                            </div>
                        ) : null}
                    </div>
                    <DataTable
                        paginator
                        value={allExecutives}
                        selection={selectedRow}
                        onSelectionChange={(e) => setSelectedRow(e.value)}
                        selectionMode="checkbox"
                        filter={filters}
                        filterDisplay="menu"
                        rows={10}
                        rowsPerPageOptions={[10, 20,50, 100]}
                        loading={loading}
                        emptyMessage="No Executive found."
                        className=""
                        showGridlines
                    >
                        <Column body={(rowData) => [rowData.firstName, rowData.lastName].filter(Boolean).join(" ") || "-"} header="Name"></Column>
                        <Column field="email" header="Email" style={{ width: "250px" }}></Column>
                        <Column
                            header="Date"
                            field="time"
                            dataType="date"
                            style={{ width: "150px" }}
                            filterMatchMode="dateIs"
                            showFilterMatchModes={true}
                            body={(rowData) => formatDate(rowData.time)}
                            filter
                            filterElement={dateFilterTemplate}
                        />
                        <Column body={image} header="Image" style={{ width: "80px" }}></Column>
                        <Column body={actions} style={{ width: "80px" }} header="Action"></Column>
                    </DataTable>
                </div>
            </div>
        </>
    );
}
